import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import FormBuscarPersona from "./FormBuscarPersona";
import { Button, Form } from "react-bootstrap";
import TextInput from "../../components/ReactHookForm/TextInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { multadoSchema, onSubmitSavePersonaMultada } from "./handlers";

const FormPersonaMultada = (props) => {
  const { setModalLlenarInfoIsOpen, dniActa, idActa, setActa } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [dni, setDni] = useState(null);
  const [personValues, setPersonValues] = useState(null);
  const {
    register,
    clearErrors,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(multadoSchema),
    defaultValues: {
      id_acta: idActa,
    },
  });

  useEffect(() => {
    const fieldsToSet = ["nombre", "apellido", "numero_de_documento", "direccion", "localidad", "provincia"];
    clearErrors();
    fieldsToSet.forEach((field) => setValue(field, personValues ? personValues[field] : null));
    !personValues && setValue("dni", dni);
  }, [personValues, dni, setValue, clearErrors]);

  return (
    <Box>
      {!dni ? (
        <FormBuscarPersona isLoading={isLoading} setIsLoading={setIsLoading} setDni={setDni} setPersonValues={setPersonValues} dniActa={dniActa} />
      ) : (
        <>
          <Button
            className='mb-3'
            onClick={() => {
              setDni(null);
              setPersonValues(null);
            }}
          >
            Buscar otra persona
          </Button>
          <Form onSubmit={handleSubmit((data) => onSubmitSavePersonaMultada(data, setIsLoading, setModalLlenarInfoIsOpen, setActa))}>
            <fieldset disabled={isLoading}>
              <div className='d-none'>
                <TextInput name='id_acta' label='ID Acta *' register={register} disabled />
              </div>
              <TextInput name='nombre' label='Nombres *' register={register} errors={errors?.nombre} disabled />
              <TextInput name='apellido' label='Apellidos *' register={register} errors={errors?.apellido} disabled />
              <TextInput name='numero_de_documento' label='DNI *' register={register} errors={errors?.numero_de_documento} disabled />
              <TextInput name='direccion' label='Direccion *' register={register} errors={errors?.direccion} />
              <TextInput name='localidad' label='Localidad *' register={register} errors={errors?.localidad} />
              <TextInput name='provincia' label='Provincia *' register={register} errors={errors?.provincia} />
              <Box className='d-flex justify-content-start mt-3'>
                {!isLoading && (
                  <Box className='d-flex flex-wrap gap-2'>
                    <Button type='submit'>Guardar</Button>
                    <Button variant='danger' onClick={() => setModalLlenarInfoIsOpen(false)}>
                      Cancelar
                    </Button>
                  </Box>
                )}
              </Box>
            </fieldset>
          </Form>
        </>
      )}
    </Box>
  );
};

export default FormPersonaMultada;
